/* eslint-disable strict */
(function () {
    'use strict';

    angular.module('legitimationUpload', [
        'legitimation.config',
        'ngSanitize',
        'ui.router'])

        .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', 'temlateUrls', function ($stateProvider, $urlRouterProvider, $httpProvider, temlateUrls) {

            $httpProvider.interceptors.push('httpInterceptor');

            $urlRouterProvider
                .otherwise('/upload');

            $stateProvider
                .state('upload', {
                    url: '/upload',
                    templateUrl: temlateUrls.upload,
                })
                .state('login', {
                    url: '/login',
                    templateUrl: temlateUrls.login,
                });
        }])

        .run(['$rootScope', function($rootScope) {
            $rootScope.$on('$stateChangeSuccess', function () {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            });
        }]);

})();
